import type { OrderEventListFiltersShared } from '@klear/order-event/order-event-list-filters-shared.wire'

export type SharedOrderEventListQueryOptions = {
  requiredFilters?: (keyof OrderEventListFiltersShared)[]
  enabled?: boolean
}

export function isSharedOrderEventListQueryEnabled(
  filters: OrderEventListFiltersShared | undefined,
  options?: SharedOrderEventListQueryOptions
): boolean {
  return (
    options?.enabled !== false &&
    (options?.requiredFilters ? options.requiredFilters.every((key) => filters && filters[key] !== undefined) : true)
  )
}
